import { fetcher } from "../utils/axios";

export default { fetcher };
